<template>
  <div class="cmi-leicester">
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/cfmchurch_bg_011.jpg);"
      ></div>
      <div class="container">
        <h1><span class="title-span">CFM</span> LEICESTER</h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/toronto">Donation causes</router-link></li>
        </ul>
      </div>
    </div>

    <section>
      <div class="block cmi-section">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h3 class="header">MANAGE DONATION INFORMATION</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <donation-causes
                :baseUrl="'Coventry/Donation/'"
              ></donation-causes>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-coventry></footer-coventry>
  </div>
</template>
<script>
import DonationCauses from "./DonationCauses";
import FooterCoventry from "./FooterCoventry";
export default {
  components: {
    DonationCauses,
    FooterCoventry
  },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {};
  }
};
</script>
